import { FC, MouseEvent, useEffect, useState } from 'react';
import { formatToBackDateTime } from '../../../helpers/date-time';
import { pageKey } from '../../../helpers/path';
import { useQueryParams } from '../../../hooks/use-query-params';
import { DateTime } from '../../date-time/date-time';
import { DropdownFilterPopup } from '../dropdown-filter-popup/dropdown-filter-popup';

interface Props {
  name: string;
  isOpen: boolean;
  onOpen: (state: boolean) => void;
}

export const DropdownFilterDateTimeRange: FC<Props> = (props) => {
  const { name, isOpen, onOpen } = props;
  const { addQueryParams, getQueryParams } = useQueryParams();
  const [from, setFrom] = useState<Date>();
  const [to, setTo] = useState<Date>();

  useEffect(() => {
    const range = getQueryParams()[name];

    if (!range) {
      return;
    }
    const asObj = JSON.parse(range);
    const from = asObj.from ? new Date(asObj.from) : undefined;
    const to = asObj.to ? new Date(asObj.to) : undefined;
    setFrom(from);
    setTo(to);
  }, [name]);

  const handleOk = (e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent> | KeyboardEvent) => {
    if (from || to) {
      addQueryParams({ [name]: JSON.stringify({ from, to }), [pageKey]: '1' });
    }
    onOpen(false);
    e.stopPropagation();
  };

  const handleReset = () => {
    addQueryParams({ [name]: undefined, [pageKey]: '1' });
    setFrom(undefined);
    setTo(undefined);
  };

  if (!isOpen) {
    return null;
  }

  return (
    <DropdownFilterPopup
      isOpen={isOpen}
      onOpen={onOpen}
      onReset={handleReset}
      onSubmit={handleOk}
      name={name}
    >
      <DateTime onChange={setFrom} value={from ? formatToBackDateTime(from) : ''} />
      <DateTime onChange={setTo} value={to ? formatToBackDateTime(to) : ''} />
    </DropdownFilterPopup>
  );
};
